import { render } from "./Works.vue?vue&type=template&id=5f024e18&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=5f024e18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f024e18"

export default script